import { StackProps, Text, VStack } from "@chakra-ui/react";
import { NotificationInterface } from "../../constants/Notification";
import { useBgHover, useDividerColor } from "../../themes/colors";
import { formatDate, formatTime } from "../../utils/helperFunction";

interface Props extends StackProps {
  data: NotificationInterface | undefined;
}

export const CardNotification = ({ data, ...rest }: Props) => {
  const bgHover = useBgHover();
  const dividerColor = useDividerColor();

  return (
    <VStack
      w={"100%"}
      p={4}
      gap={0.5}
      align={"stretch"}
      cursor={"pointer"}
      borderBottomWidth={"1px"}
      borderBottomColor={dividerColor}
      _hover={{ bg: bgHover }}
      {...rest}
    >
      <Text textStyle={"b-reg-sb"}>{data?.title}</Text>
      <Text textStyle={"b-sm"}>{data?.body}</Text>

      <Text fontSize={[10, null, 12]} variant={"secondary"} mt={2}>
        {data &&
          `${formatDate(data.created_at.toString())} Jam ${formatTime(
            data.created_at.toString()
          )}`}
      </Text>
    </VStack>
  );
};
